import { render, staticRenderFns } from "./TermsOfAcceptanceTable.vue?vue&type=template&id=3da9d522&"
import script from "./TermsOfAcceptanceTable.vue?vue&type=script&lang=js&"
export * from "./TermsOfAcceptanceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports